'use client'

import { i18n } from '@lingui/core'
import { I18nProvider as LinguiProvider } from '@lingui/react'
import * as React from 'react'

import { TLanguage } from '~config/locales'

import { activateLinguiLocale } from './activateLocale'

type TProps = RequiredChildren & {
  initialLocale: TLanguage['code']
  catalogs: RoA<string>
}
/**
 * Activates the locale & provides the `i18n` from '@lingui/core'
 */
export const I18nProvider: React.FC<TProps> = ({ children, initialLocale, catalogs }) => {
  React.useEffect(() => {
    activateLinguiLocale(initialLocale, catalogs)
  }, [catalogs, initialLocale])

  return <LinguiProvider i18n={i18n}>{children}</LinguiProvider>
}
